import React from 'react';
import { createPortal } from 'react-dom';

const DARK_COLOR = '#444444';
const ACCENT_COLOR = '#fec35c';

interface BetaWelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onViewAnnouncement: () => void;
}

export const BetaWelcomeModal: React.FC<BetaWelcomeModalProps> = ({
  isOpen,
  onClose,
  onViewAnnouncement,
}) => {
  if (!isOpen) return null;

  const handleViewClick = () => {
    onViewAnnouncement();
    onClose();
  };

  return createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 5000,
        padding: '1rem',
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '4px',
          padding: '2rem',
          maxWidth: '400px',
          width: '100%',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          textAlign: 'center',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          style={{
            fontSize: '1.25rem',
            fontWeight: 600,
            color: DARK_COLOR,
            marginBottom: '1rem',
            fontFamily: 'Lato, system-ui, sans-serif',
          }}
        >
          Welcome to Lupa Beta!
        </h2>
        <p
          style={{
            fontSize: '0.875rem',
            color: '#666',
            marginBottom: '1.5rem',
            lineHeight: 1.6,
            fontFamily: 'Lato, system-ui, sans-serif',
          }}
        >
          Thank you for joining our beta program. We have some important information for you to review before getting started.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <button
            onClick={handleViewClick}
            style={{
              padding: '0.875rem 1.5rem',
              backgroundColor: ACCENT_COLOR,
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '0.875rem',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              fontFamily: 'Lato, system-ui, sans-serif',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f16952';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = ACCENT_COLOR;
            }}
          >
            View Welcome Announcement
          </button>
          <button
            onClick={onClose}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: 'transparent',
              color: '#666',
              border: 'none',
              borderRadius: '4px',
              fontSize: '0.875rem',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'color 0.2s',
              fontFamily: 'Lato, system-ui, sans-serif',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = DARK_COLOR;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#666';
            }}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default BetaWelcomeModal;
